/*
* @Des 组件 电子围栏
* @Description
* @Author
* @Date 2021/8/2
*/
/* HTML */
<template>
	<div :class="{'_table-item-box view-page-box position-map-view padding-l-none': true, 'max-box': !showTreeBoxFlag}">
		<section style="height: 100%;">

			 <!-- 主内容 start -->
			 <div :class="{'page-box': true, '_no-items': this.$checkEmpty(fences)}">

			 	<!-- 地图 容器 -->
			 	<div class="map-box">
			 		<SubRaphaelMap ref="svgMap" :class="{'off': this.$checkEmpty(maps)}" :mapEleId="'svg_map_fence'" />
			 		<div :class="{'none-map-item': true, 'off': !this.$checkEmpty(maps)}" >
			 			<img alt="加载中" v-show="orgLoadingFlag" title="加载中" src="@/static_dazzle/images/loading_1.gif" >
			 			<img alt="暂无地图" v-show="!orgLoadingFlag" title="暂无地图" src="@/static_dazzle/images/map_none.png" >
			 		</div>
			 	</div>

			 	<el-col class="page-box-handles" v-if="false" v-show="maps.length > 0">
					<el-button v-if="false && !newRow.addRowFlag" type="primary" icon="el-icon-plus" size="mini" trigger="click" @click="addRow()" >新增电子围栏</el-button>
					<span v-if="newRow.addRowFlag" style="margin-right: 5px;font-size: 16px;">双击地图绘制电子围栏</span>
					<el-button v-if="newRow.addRowFlag" type="primary" icon="el-icon-close" size="mini" trigger="click" @click="cancelDraw()" >取消绘制</el-button>
					<el-button v-if="newRow.addRowFlag" type="primary" icon="el-icon-check" size="mini" trigger="click" @click="endDraw()" >完成绘制</el-button>
	            </el-col>

			 	<!-- 电子围栏列表 start -->
				<div class="items-box">
					
					<!-- row-item-box start -->
					<div :class="{'row-item-box': true, 'on': item.editNameFlag, 'item-detail-showed': item.showDetailFlag}" v-for="(item, index) in fences" :key="index" @mouseover="MouseOverDiv(item)" @mouseout="MouseOutDiv(item)">
						<span class="el-icon-arrow-right item-detail-btn cursor-pointer" title="详情" @click="toggleItemDetail(item, index)"></span>
						<!-- row-item-content start -->
						<div class="row-item-content row-item-title">
							<span class="item-content-label">名称：</span>
							<div class="item-content-wrap" @dblclick="edtiItemName(item, index)" title="双击编辑名称">
								<el-input :ref="'itemNameInp_' + index" v-model="item.eName" @keyup.enter.native="enterItemName(item, index)" @blur="saveItemName(item, index)" clearable :disabled="!item.editNameFlag" />
							</div>
						</div>
						<!-- row-item-content end -->
						
						<!-- item-detail-box start -->
						<div class="item-detail-box" v-for="r in item.eFenceInConfList" :key="r.eConfId">
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">处理类型：</span>
								<div class="item-content-wrap">{{r.dealMethod == 1 ? '系统自动处理' : '手动处理'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div v-if="r.eType == 7" class="row-item-content">
								<span class="item-content-label">聚众区域：</span>
								<div class="item-content-wrap"><i style="padding-right: 10px;">{{transRules(r.rules, r.eType)['rangeX']}}米</i>X<i style="padding-left: 10px;">{{transRules(r.rules, r.eType)['rangeY']}}米</i></div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div v-if="r.eType == 7" class="row-item-content">
								<span class="item-content-label">聚众人数：</span>
								<div class="item-content-wrap">{{transRules(r.rules, r.eType)['peopleNum']}}人</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div v-if="r.eType == 8" class="row-item-content">
								<span class="item-content-label">周界阈值：</span>
								<div class="item-content-wrap">{{!$checkEmpty(r.rules) && !$checkEmpty(r.rules.split(';')[0]) ? (r.rules.split(';')[0] + '米') : '----'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div v-if="r.eType == 8" class="row-item-content">
								<span class="item-content-label">周界类型：</span>
								<div class="item-content-wrap">{{!$checkEmpty(r.rules) && r.rules.split(';')[0] == '2' ? '禁止离开' : '禁止进入'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">时间周期：</span>
								<div class="item-content-wrap">{{JSON.parse(r.timeCycle).join('，')}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">配置类型：</span>
								<div class="item-content-wrap">{{transUserGroupsTit(r.isAllow, r.eType)}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">关联对象：</span>
								<div class="item-content-wrap">{{r.relationType == 1 ? '人员' : '工具'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">关&ensp;联&ensp;组：</span>
								<div class="item-content-wrap">{{transUserGroups(r.eFenceInConfSetList)}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">是否开启：</span>
								<div class="item-content-wrap">{{r.isOpen == 1 ? '开启' : '关闭'}}</div>
							</div>
							<!-- row-item-content end -->
						</div>
						<!-- item-detail-box end -->
						
						<!-- item btns box start -->
						<div class="item-btns-box" >
	                    	<i v-if="item.editFlag" class="el-icon-close" title="取消" @click="cancelEditRow(item, index)">取消</i>
	                    	<i v-if="item.editFlag" class="el-icon-check" title="保存" @click="sureEditRow(item, index)">保存</i>
	                    	<i v-if="!item.editFlag" class="el-icon-edit" title="编辑配置" @click="editRowForm(item, index)">编辑配置</i>
	                    	<i v-if="!item.editFlag" class="iconfont el-icon-my_dianziweilan1" title="编辑区域" @click="editRow(item, index)">编辑区域</i>
	                    	<i v-if="!item.editFlag" class="el-icon-delete" title="删除" @click="removeRow(item, index)">删除</i>
	                    </div>
	                    <!-- item btns box end -->
	                    
					</div>
					<!-- row-item-box end -->
					
					<!-- 按钮 新增 -->
					<el-button class="item-btn-row" v-if="!newRow.addRowFlag && fences.length > 0" title="新增电子围栏" type="primary" icon="el-icon-circle-plus-outline" size="mini" trigger="click" @click="addRow()" >新增电子围栏</el-button>
					<el-button class="item-btn-row whole-page-row" v-if="!newRow.addRowFlag && fences.length == 0" title="新增电子围栏" type="primary" icon="el-icon-circle-plus-outline" size="mini" trigger="click" @click="addRow()" ><span><br />新增电子围栏</span></el-button>
					
					<div v-if="newRow.addRowFlag" :class="{'item-btn-row': true, 'whole-page-row': fences.length == 0}">
						<span v-if="newRow.addRowFlag">双击地图绘制电子围栏</span><br />
						<el-button type="primary" icon="el-icon-close" size="mini" trigger="click" @click="cancelDraw()" >取消绘制</el-button>
						<el-button type="primary" icon="el-icon-check" size="mini" trigger="click" @click="endDraw()" >完成绘制</el-button>
					</div>
					
			 	</div>
			 	<!-- 电子围栏列表 end -->

			 	<!-- 区域列表 start -->
			 	<div class="area-items-box" v-show="areas.length > 0">
			 		<ul>
			 			<li v-for="(item, index) in areas"
			 				:key="index"
			 				:class="{'on': item.areaId == filters.areaId}"
			 				:title="item.label"
			 				@click="changeArea(item)">{{item.label}}</li>
			 			<li v-if="this.$checkEmpty(areas)" title="暂无区域">暂无区域</li>
			 		</ul>
			 	</div>
			 	<!-- 区域列表 end -->

			 	<!-- 地图列表 start -->
			 	<div class="map-items-box" v-show="maps.length > 0">
			 		<ul>
			 			<li v-for="(item, index) in maps"
			 				:key="index"
			 				:class="{'on': item.mapId == filters.mapId}"
			 				:title="item.mapName"
			 				@click="changeMap(item)">{{item.mapName}}</li>
			 			<li v-if="this.$checkEmpty(maps)" title="暂无地图">暂无地图</li>
			 		</ul>
			 	</div>
			 	<!-- 区域列表 end -->

			 </div>
			 <!-- 主内容 end -->

			<FenceDialog ref="fenceDialog" :userGroups="userGroups"/>

		</section>
	</div>
</template>

/* JS */
<script>
    // 公共变量
    import GlobalVariable from '@/global/global-variable'
    // 公共方法
    import GlobalFun from '@/global/global-function'
    
    // 围栏信息 API
    import ApiFence from '@/request/api-fence'
	// API 组织结构
	import ApiOam from "@/request/api-oam"
	// API 人员
	import ApiUser from "@/request/api-user"
    
    // svg地图 组件
    import SubRaphaelMap from '@/components/SubRaphaelMap'
    // dialog 组件
    import FenceDialog from './FenceDialog'

    export default {
        name: "ElectronicFence",
        props: {
            /**
             * @Des 展示box
             * @Auth
             * @Date 2021/8/2
             */
            showTreeBoxFlag: {
                type: Boolean,
                default: function (){
                    return true
                }
            },
            /**
             * @Des 当前选中 tab
             * @Auth
             * @Date 2021/8/2
             */
            activePane: {
                type: Object,
                default: function (){
                    return {};
                }
            },
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/8/2
         */
        components: {
            // svg地图 组件
            SubRaphaelMap,
            // dialog 组件
			FenceDialog,
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/8/2
         */
        data() {
            return {
                /**
	             * @Des filters
	             * @Auth
	             * @Date 2021/8/2
	             */
                filters: {
                    areaId: '',
                    mapId: '',
                },
                // svg elem
                mapSub: this.$refs.svgMap,
				newRow: {
					// 新增flag
					addRowFlag: false,
					// 点集合
					points: [],
					// 名称
					eName: '',
					// type
					eType: this.activePane.eType,
					// 人员组 集合
					userGroupIds: [],
				},
				
				// 围栏参数
				lineObj: {color: 'blue',width: 4},
				
				// 加载 组织结构 flag
				orgLoadingFlag: true,
				// 组织结构 list
				orgList: [],
				// 地图 总list
				orgMaps: [],
                // 区域
                areas: [],
                // 地图
                maps: [],
                // 缓存  记录 区域信息
				map_list_areas: new this.HashMap(),
				// 缓存  记录 地图信息
				map_list_maps: new this.HashMap(),
                
                // 人员组
                userGroups: [],
                // 电子围栏
                fences: [],
                // 记录 电子围栏
                fenceRow: {},
                // 记录 电子围栏名称
                fenceNameRow: {},
                // 首尾点 最小距离
                limitDis: 20,
                locked_add: false,
                locked_update: false,
                locked_remove: false,
            }
        },
        mounted() {
			// 查询人员组
			this.searchUserGroup();
        },
        /**
         * @Des 加载完成
         * @Auth
         * @Date 2021/8/2
         */
        created() {
        	// 延时执行
        	this.$nextTick(() => {
        		// svg elem
                this.mapSub = this.$refs.svgMap;

                // 查询结构
                this.searchOrg();
        	});
        },
        /**
         * @Des 销毁
         * @Auth
         * @Date 2021/8/2
         */
        destroyed() {
        	// 销毁 svg地图
			this.mapSub.destroySvg();
        },
		methods: {
			/**
			 * @Des 鼠标进入
			 * @Auth
			 * @Date
			 */
			MouseOverDiv(row){
				if(!row.editFlag){
					// 清除 电子围栏
					this.mapSub.clearRail(row.id, 'destroy');
					this.lineObj = {
						color: 'red',
						width: 4
					}
					this.refreshMapFence(row);
				}
			},// mouseMoveDiv
			/**
			 * @Des 鼠标离开
			 * @Auth
			 * @Date
			 */
			MouseOutDiv(row){
				if(!row.editFlag){
					// 清除 电子围栏
					this.mapSub.clearRail(row.id, 'destroy');
					this.lineObj = {
						color: 'blue',
						width: 4
					}
					this.refreshMapFence(row);
				}
			},// MouseOutDiv
			
			/**
             * @Des 查询 组织结构
             * @Auth
             * @Date 
             */
            searchOrg() {
                // 加载 组织结构 flag
				this.orgLoadingFlag = true;
                this.$request.postJsonRequest(ApiOam.Find_Org_Uri,{
                    projectId: this.$store.state.currentProjectId
                }).then(result => {
                    //console.log(result); return false;
                    // 组织结构 list
                    this.orgList = Object.assign([], result.data);
                    
                    let orgAreas = [];// 区域
                    let orgMaps = [];// 地图
                    // 缓存
					this.map_list_areas.clear();
                    // 缓存 区域
                    this.orgList.forEach((row, index) => {
                    	// 空值 跳过
                    	if (this.$checkEmpty(row)) return true;
                    	
                    	if (row.level == 2) {
                    		// 区域
                    		orgAreas.push(Object.assign({}, row.node, {label: row.node.areaName}));
                    		// 缓存
                    		this.map_list_areas.put(row.areaId, Object.assign({}, row.node, {label: row.node.areaName}));
                    	}
                    	if (row.level == 3) {
                    		// 地图
                    		orgMaps.push(Object.assign({}, row.node));
                    	}
                    });
                    
                    // 区域
                    this.areas = Object.assign([], orgAreas);
                    // 地图
                    this.orgMaps = Object.assign([], orgMaps);
                    
                    // 当前选中项
                    let currItem = this.getCurrItem(this.areas, this.filters.areaId, 'areaId');
                    // 切换区域
                    this.changeArea(currItem);
                    // 加载 组织结构 flag
                    this.orgLoadingFlag = false;
                }).catch(error => {
                    console.error('查询组织结构异常', ApiOam.Find_Org_Uri, error);
                    // 加载 组织结构 flag
                    this.orgLoadingFlag = false;
                })
            },
            /**
             * @Des 切换区域
             * @Auth
             * @Date 2021/8/2
             */
            changeArea(row) {
            	//console.log(row);
            	// filters
            	this.filters.areaId = Object.assign({areaId: '', mapId: ''}, row).areaId;

            	// 查询地图
            	this.searchMaps();
            },

            /**
             * @Des 查询地图
             * @Auth
             * @Date 2021/8/6
             */
            searchMaps() {
                // 地图集合
                this.maps = [];
                // 缓存 地图
                this.orgMaps.forEach((row, index) => {
                	// 空值 跳过
                	if (this.$checkEmpty(row)) return true;
                	
                	// 没有区域 || 地图处于当前区域
                	if (this.$checkEmpty(this.areas) || row.areaId == this.filters.areaId) {
                		let itemRow = Object.assign({}, row);
                		// 检索 当前区域
                		let currArea = this.map_list_areas.get(this.filters.areaId);
                		// 区域有地铁
                		if (!this.$checkEmpty(currArea) && currArea.hasMap == 1) {
                			itemRow.pStartPointX = currArea.startPointX;
                			itemRow.pStartPointY = currArea.startPointY;
                			itemRow.pStartPointZ = currArea.startPointZ;
                			itemRow.pHasMap = true;
                		}
                		// 缓存 地图
                		this.maps.push(Object.assign({}, itemRow));
                	}
                });
                
                // 当前选中项
                let currItem = this.getCurrItem(this.maps, this.filters.mapId, 'mapId');
                // 目标空值
                if (this.$checkEmpty(currItem)) {
                	// 检索 当前区域
                	let currArea = this.map_list_areas.get(this.filters.areaId);
                	if (!this.$checkEmpty(currArea) && !this.$checkEmpty(currArea.mapUrl)) {
                		// 初始化 svg地图
						//this.mapSub.initMap(Object.assign({}, currArea, {mapUrl: (GlobalVariable.BASE_PATH + currArea.mapUrl)}));
						this.mapSub.initMap(Object.assign({}, currArea, {mapUrl: ('data:image/png;base64,' + currArea.mapUrl), mapLevel: 1, tunnelPoints: currArea.tunnelPoints}));
		            	// 查询实时定位
		            	this.searchFence();
		            	// 查询基站
		            	this.searchBaseStation();
		            	// 查询工具柜
		            	//this.searchToolkits();
		            	
		            	// 初始化 当前场景 人员信息
		            	this.initPosiData();
                	} else {
                		// 切换地图
                		this.changeMap(this.maps[0]);
                	}
                	return false;
                }
                // 切换地图
                this.changeMap(currItem);
            },
            /**
             * @Des 切换地图
             * @Auth
             * @Date 2021/8/2
             */
            changeMap(row) {
            	// 取消 绘制
            	this.cancelDraw();
            	// 清除图元 电子围栏
				this.clearMapFences();

            	// 空值 中止
            	if (this.$checkEmpty(row)) {
            		// 清除记录
					this.fenceRow = {};
	            	// filters
					this.filters.mapId = null;
            		// 更新数据
                    this.fences = [];

            		// 销毁 svg地图
					this.mapSub.destroySvg();
            		return false
            	};

            	//console.log(row);
            	// filters
            	this.filters.mapId = Object.assign({areaId: '', mapId: ''}, row).mapId;

            	// 初始化 svg地图
				//this.mapSub.initMap(Object.assign({}, row, {mapUrl: (GlobalVariable.BASE_PATH + row.mapUrl)}));
				this.mapSub.initMap(Object.assign({}, row, {mapUrl: ('data:image/png;base64,' + row.mapUrl), mapLevel: 2, tunnelPoints: row.tunnelPoints}));

            	// 查询电子围栏
            	this.searchFence();
            },
            /**
             * @Des 当前选中项
             * @Auth
             * @Date 2021/8/2
             */
            getCurrItem(rows, onkey, key) {
            	// 空值 中止
            	if (this.$checkEmpty(rows)) return false;

            	// onrow
            	let onRow = null;
            	if(rows.length > 0){
                    // 遍历 检索
                    rows.forEach((row, index) => {
                        if (onkey == row[key]) {
                            onRow = row;
                        }
                    });
                }
                return (onRow == null ? rows[0] : onRow);
            },

            /**
             * @Des 添加电子围栏
             * @Auth
             * @Date 2021/8/2
             */
            addRow() {
                if (!this.$checkEmpty(this.fenceRow)) {
                	// 取消 编辑
                	this.cancelEditRow(this.fences[this.fenceRow.index], this.fenceRow.index);
                }

                // 添加状态
                this.newRow.addRowFlag = true;
                // 点集合
                this.newRow.points = [];
                // 名称
                this.newRow.eName = '';
                // 人员组
                this.newRow.userGroupIds = '';

                // 设置 点集合
                this.mapSub.setPointGroupData([]);
                // 绘制 区域
                this.mapSub.drawArea(true, (pointXY, points, disToFirst, realPoints) => {
                	// 自动完成
                	if (points.length >= 4 && disToFirst <= this.limitDis) {
                		// 完成 绘制
                		this.endDraw();
                	}
                }, {color: 'blue', width: 4, limitDis: this.limitDis});
            },
            /**
             * @Des 取消绘制
             * @Auth
             * @Date 2021/8/2
             */
            cancelDraw(option) {
                // 添加状态
                this.newRow.addRowFlag = false;
                // 点集合
                this.newRow.points = [];
                // 名称
                this.newRow.eName = '';
                // 人员组
                this.newRow.userGroupIds = '';

                // 设置 点集合
                this.mapSub.setPointGroupData([]);
                // 绘制 区域
                this.mapSub.drawArea(false, (pointXY, points, disToFirst, realPoints) => {
                	//console.log({pointXY, points});
                });
            },
            /**
             * @Des 完成绘制
             * @Auth
             * @Date 2021/8/2
             */
            endDraw(option) {
				// 获取 点集合
				this.newRow.points = this.mapSub.getDrowPoints();
				// 少于3个点
				if (this.newRow.points.length < 3) {
					this.$message({
                        message: '坐标点不可少于3个',
                        type: 'error',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
				}
				// 首尾相接
				if (this.newRow.points[0] != this.newRow.points[this.newRow.points.length -1]) {
					this.newRow.points.push(this.newRow.points[0]);
				}

				// 绘制 区域
                this.mapSub.drawArea(false, (pointXY, points, disToFirst, realPoints) => {
                	//console.log({pointXY, points});
                });

				let rowOpt = {
					projectId: this.$store.state.currentProjectId,
					areaId: this.filters.areaId,
					mapId: this.filters.mapId,
					eName: this.newRow.eName,
					eType: parseInt(this.activePane.eType),
					points: this.newRow.points.join(';'),
					userGroupIds: this.newRow.userGroupIds,
				};
				this.$refs.fenceDialog.openDialog(false, '新增电子围栏（'+ this.activePane.label +'）', rowOpt);
            },
            /**
             * @Des 提交 新增
             * @Auth
             * @Date 2021/8/2
             */
            requestAdd() {
            	// 交互锁 编辑
                if(this.locked_add) return false;
                this.locked_add = true;

				// 交互
				this.$request.postJsonRequest(ApiFence.addFenceApi, {
					projectId: this.$store.state.currentProjectId,
					areaId: this.filter.areaId,
					mapId: this.filter.mapId,
					eName: this.newRow.eName,
					points: this.newRow.points,
					type: this.newRow.type,
					userGroupIds: this.newRow.userGroupIds,
				}).then(result => {
                    if (result.code == 0) {
                        this.$message({
                            message: '添加成功！',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        // 查询电子围栏
                        this.searchFence();
                    } else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }

                    // 点集合
	                this.newRow.points = [];
	                // 名称
	                this.newRow.eName = '';
	                // 人员组
					this.newRow.userGroupIds = '';

                    // 交互锁 编辑
	                this.locked_add = false;
                }).catch(error => {
                    // 点集合
	                this.newRow.points = [];
	                // 名称
	                this.newRow.eName = '';
	                // 人员组
					this.newRow.userGroupIds = '';

                    // 交互锁 编辑
	                this.locked_add = false;
	                
	                console.error('添加电子围栏异常', ApiFence.addFenceApi, error);
                })
            },
			
			/**
			 * @Des 详情
			 * @Auth
			 * @Date 
			 */
			toggleItemDetail(row, index) {
				// 详情状态
                this.$set(this.fences[index], 'showDetailFlag', !row.showDetailFlag);
			},// toggleItemDetail
			
			/**
			 * @Des 编辑名称
			 * @Auth
			 * @Date 
			 */
			edtiItemName(row, index) {
				// 已开始编辑 中止
				if (row.editNameFlag) return false;
				
				// 正在编辑其他
				if (!this.$checkEmpty(this.fenceNameRow) && this.fenceNameRow.index != index) {
					this.$message({
                        message: '手速过快，请稍候重试',
                        type: 'info',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
				}
				
				// 记录 电子围栏名称
                this.fenceNameRow = Object.assign({}, row, {index: index});
				
				// 详情状态
                this.$set(this.fences[index], 'editNameFlag', true);
                
                // 延迟执行
                this.$nextTick(() => {
                	// input 获取焦点
                  	this.$refs['itemNameInp_' + index][0].focus();
                });
			},// edtiItemName
			
			/**
			 * @Des 编辑名称 enter
			 * @Auth
			 * @Date 
			 */
			enterItemName(row, index) {
				// input 获取焦点
				this.$refs['itemNameInp_' + index][0].blur();
			},// enterItemName
			
			/**
			 * @Des 编辑名称 保存
			 * @Auth
			 * @Date 
			 */
			saveItemName(row, index) {
				// 空值
				if (this.$checkEmpty(row.eName)) {
					// 数据还原
					this.$set(this.fences, index, Object.assign({}, this.fenceNameRow));
					// 还原inpt状态
					this.resetNameInp(index);
                	return false;
				}
				
				// 未改变
				if (row.eName.trim() == this.fenceNameRow.eName.trim()) {
					// 还原inpt状态
					this.resetNameInp(index);
                	return false;
				}
				
				// 交互 编辑名称
				this.requestSaveName(row, index);
				
			},// saveItemName
			
			/**
			 * @Des 还原inpt状态
			 * @Auth
			 * @Date 
			 */
			resetNameInp(index) {
				// 记录 电子围栏名称
                this.fenceNameRow = {};
				// 详情状态
                this.$set(this.fences[index], 'editNameFlag', false);
			},// resetNameInp
			
			/**
			 * @Des 交互 编辑名称
			 * @Auth
			 * @Date 
			 */
			requestSaveName(row, index) {
				// 整理 表单参数
                let _formData = this.sortRowForm(Object.assign({}, row));
                // 交互 参数
				let formData = Object.assign({}, _formData, {projectId: this.$store.state.currentProjectId, eId: row.eId});
				
				// 交互
				this.$request.postJsonRequest(ApiFence.updateFenceApi, formData).then(result => {
					// 交互锁 编辑
					this.locked_update = false;
					
                    if (result.code == 0) {
                        this.$message({
                            message: '编辑成功！',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.$set(this.fences, index, row);
                    } else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        // 数据还原
						this.$set(this.fences, index, Object.assign({}, this.fenceNameRow));
                    }
					
					// 还原inpt状态
					this.resetNameInp(index);
                }).catch(error => {
                    // 交互锁 编辑
	                this.locked_update = false;
	                // 数据还原
	                this.$set(this.fences, index, Object.assign({}, this.fenceNameRow));
	                // 还原inpt状态
					this.resetNameInp(index);
	                
	                console.error('编辑电子围栏名称异常', ApiFence.updateFenceApi, error);
                })
			},// requestSaveName
			
            /**
             * @Des 关联人员组
             * @Auth
             * @Date 2021/8/2
             */
            editRowForm(row, index) {
            	if (!this.$checkEmpty(this.fenceRow)) {
                	// 取消 编辑
                	this.cancelEditRow(this.fences[this.fenceRow.index], this.fenceRow.index);
                }

            	// 取消 绘制
            	this.cancelDraw();

            	// 整理 表单参数
            	let rowOpt = this.sortRowForm(row);
				this.$refs.fenceDialog.openDialog(true, '编辑电子围栏（'+ this.activePane.label +'）', rowOpt);
            },

            /**
             * @Des 编辑电子围栏
             * @Auth
             * @Date 2021/8/2
             */
            editRow(row, index) {
				
                if (!this.$checkEmpty(this.fenceRow)) {
                	// 取消 编辑
                	this.cancelEditRow(this.fences[this.fenceRow.index], this.fenceRow.index);
                }

                // 取消 绘制
            	this.cancelDraw();

                this.fenceRow = Object.assign({}, row, {index: index});
                // 编辑状态
                this.$set(this.fences[index], 'editFlag', true);

                let points = row.points.split(';');
                // 去除首尾相同坐标
                if (points[0] == points[points.length -1]) {
                	points.splice(points.length -1, 1);
                }

                // 清除 电子围栏
				this.mapSub.clearRail(row.id, 'destroy');
                // 设置 点集合
                this.mapSub.setPointGroupData(points);
                // 绘制 区域
                this.mapSub.drawArea(true, (pointXY, points, disToFirst, realPoints) => {
                	// 自动完成
                	if (points.length >= 4 && disToFirst <= this.limitDis) {
                		// 确认 编辑
                		this.sureEditRow(row, index);
                	}
                }, {color: 'blue', width: 4, limitDis: this.limitDis});

            },
            /**
             * @Des 取消 编辑
             * @Auth
             * @Date 2021/8/2
             */
            cancelEditRow(row, index) {
            	// 数据还原
				this.reductionRow(row, index);
                // 编辑状态
                this.$set(this.fences[index], 'editFlag', false);

                // 清除 区域
				this.mapSub.clearDrawArea();
				// 绘制图元
				this.refreshMapFence(row);

            },
            /**
             * @Des 确认 编辑
             * @Auth
             * @Date 2021/8/2
             */
            sureEditRow(row, index) {

            	// 编辑状态
            	this.$set(this.fences[index], 'editFlag', false);

                // 交互锁 编辑
                if(this.locked_update) return false;
                this.locked_update = true;

                // 获取 点集合
				let points = this.mapSub.getDrowPoints();
				// 少于3个点
				if (points.length < 3) {
					this.$message({
                        message: '坐标点不可少于3个',
                        type: 'error',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
				}
				// 首尾相接
				if (points[0] != points[points.length -1]) {
					points.push(points[0]);
				}

				// 绘制 区域
                this.mapSub.drawArea(false, (pointXY, points, disToFirst, realPoints) => {
                	//console.log({pointXY, points});
                });
                // 更新 区域坐标
                row.points = points.join(';');

                // 整理 表单参数
                let _formData = this.sortRowForm(row);
                // 交互 参数
				let formData = Object.assign({}, _formData, {projectId: this.$store.state.currentProjectId, eId: row.eId});

				// 交互
				this.$request.postJsonRequest(ApiFence.updateFenceApi, formData).then(result => {
                    if (result.code == 0) {
                        this.$message({
                            message: '编辑成功！',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.$set(this.fences, index, row);
                        this.locked_update = false;

                    } else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        // 数据还原
						this.reductionRow(row, index);
                        this.locked_update = false;
                    }

                    // 清除 区域
					this.mapSub.clearDrawArea();
                    // 绘制图元
					this.refreshMapFence(this.fences[index]);

					// this.cancelEditRow(row, index);

                }).catch(error => {
                    // 清除 区域
					this.mapSub.clearDrawArea();
                    // 交互锁 编辑
	                this.locked_update = false;
	                
	                console.error('编辑电子围栏异常', ApiFence.updateFenceApi, error);
                })

            },
            // 数据还原
            reductionRow(row, index) {
            	let fenceRow = Object.assign({}, this.fenceRow);
            	// 数据还原
				this.$set(this.fences, index, fenceRow);
				// 清除记录
				this.fenceRow = {};
            },

            /**
             * @Des 删除电子围栏
             * @Auth
             * @Date 2021/8/2
             */
            removeRow(row, index) {
                if(this.locked_removeRow) return false;
                this.locked_removeRow = true;

                if (!this.$checkEmpty(this.fenceRow)) {
                	// 取消 编辑
                	this.cancelEditRow(this.fences[this.fenceRow.index], this.fenceRow.index);
                }

                // 取消 绘制
            	this.cancelDraw();

                // 弹框确认
                this.$confirm('确定要删除电子围栏【' + row.eName + '】吗？','提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    this.$request.postJsonRequest(ApiFence.deleteFenceApi, {
                    	projectId: this.$store.state.currentProjectId,
                        mapId: row.mapId,
                        eId: row.eId,
                    }).then(result => {
                        if (result.code == 0) {
                            this.$message({
                                message: '删除成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            // 从map list中 移除
                            this.fences.splice(index,1);
                            // 清除 电子围栏
							this.mapSub.clearRail(row.id, 'destroy');
							
							// 右侧内容改变
							//this.$emit('changeRightFlag', this.fences.length > 0);
                        } else {
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.locked_removeRow = false;
                    }).catch(error => {
                    	this.locked_removeRow = false;
                    	console.error('删除电子围栏异常', ApiFence.deleteFenceApi, error);
                    })
                }).catch(() => {
                    this.locked_removeRow = false;
                })
            },
            /**
             * @Des 查询电子围栏
             * @Auth
             * @Date 2021/8/2
             */
            searchFence() {
				// 清除记录
				this.fenceRow = {};
				// 取消 绘制
            	this.cancelDraw();

				// 清除图元 电子围栏
				this.clearMapFences();

				// 交互 参数
				let formData = {
					projectId: this.$store.state.currentProjectId,
					subsectionId: this.filters.areaId,
					mapId: this.filters.mapId,
					eType: parseInt(this.activePane.eType),
				};
				// 交互
				this.$request.postJsonRequest(ApiFence.searchFenceApi, formData).then(result => {

                    // 更新数据
                    this.fences = !this.$checkEmpty(result.rows) ? result.rows : [];
                    // 右侧内容改变
                    //this.$emit('changeRightFlag', this.fences.length > 0);

                    // 绘制图元
                    this.refreshMapFences();

                }).catch(error => {
                    console.error('查询电子围栏异常', ApiFence.searchFenceApi, error);
                })
            },

            /**
             * @Des 查询人员组
             * @Auth
             * @Date 2021/8/2
             */
            searchUserGroup() {
				// 交互 参数
				let formData = {
					subsectionId: this.filters.areaId,
					mapId: this.filters.mapId,
					projectId: this.$store.state.currentProjectId
				};
				// 交互
				this.$request.postJsonRequest(ApiUser.searchUserGroupApi, formData).then(result => {
					
                    // 更新数据
                    //this.userGroups = !this.$checkEmpty(result.rows) ? result.rows : [];
                    let rows = !this.$checkEmpty(result.data) ? result.data : [];
                    this.userGroups = GlobalFun.dataToTree(rows, {
                        id: 'id',
                        pid: 'parentId',
                        children: 'children',
                        label: 'name',
                        type: 'type',
                    });

                }).catch(error => {
                    console.error('查询人员分组异常', ApiUser.searchUserGroupApi, error);
                })
            },

			/**
			 * @Des 清除图元 电子围栏
			 * @Auth
			 * @Date 2021/8/2
			 */
			clearMapFences() {
				// 清除 图元
                if(this.fences.length > 0){
                    this.fences.forEach((row, index) => {
                        // 空值 跳过
                        if (this.$checkEmpty(row)) return true;

                        // 绘制 电子围栏
                        this.mapSub.clearRail(row.id, 'destroy');
                    });
                }
			},
			/**
			 * @Des 绘制图元 电子围栏
			 * @Auth
			 * @Date 2021/8/2
			 */
			refreshMapFence(row) {
				// 空值 跳过
				if (this.$checkEmpty(row)) return true;
				// 清除 电子围栏
				this.mapSub.clearRail(row.id, 'destroy');

				// points
				let points = row.points.split(';');
				points.push(points[0]);
				
				// railObj
				let railObj = {id: row.id, row: row, points: points, lineObj: this.lineObj};

				// 绘制 电子围栏
				this.mapSub.loadRail(railObj);
			},
			/**
			 * @Des 绘制图元 电子围栏
			 * @Auth
			 * @Date 2021/8/2
			 */
			refreshMapFences() {
				// 重新绘制
                if(this.fences.length > 0){
                    this.fences.forEach((row, index) => {
                        // 空值 跳过
                        if (this.$checkEmpty(row)) return true;

                        // points
                        let points = row.points.split(';');
                        points.push(points[0]);
                        
                        // railObj
                        let railObj = {id: row.id, row: row, points: points, lineObj: this.lineObj};

                        // 绘制 电子围栏
                        this.mapSub.loadRail(railObj);
                    });
                }
			},

            /**
			 * @Des 翻译 围栏类型
			 * @Auth
			 * @Date 2021/8/2
			 */
            transEType(eType) {
            	let _eType = '入界报警';
            	switch(String(eType)) {
            		case '1':
            			_eType = '入界报警';
            			break;
            		case '2':
            			_eType = '出界报警';
            			break;
            		case '7':
            			_eType = '聚众报警';
            			break;
            		case '8':
            			_eType = '周界报警';
            			break;
            		default:
            			_eType = '入界报警';
            	};
            	return _eType;
            },

            /**
			 * @Des 翻译 配置人员组 标题
			 * @Auth
			 * @Date 2021/8/2
			 */
            transUserGroupsTit(isAllow, eType) {
            	// isAllow to str
            	let isAllowStr = isAllow == 1 ? '允许' : '不允许';

            	let eTypeStr = '入界';
            	switch(String(eType)) {
            		case '1':
            			eTypeStr = '入界';
            			break;
            		case '2':
            			eTypeStr = '出界';
            			break;
            		case '7':
            			eTypeStr = '聚众';
            			break;
            		case '8':
            			eTypeStr = '靠近周界';
            			break;
            		default:
            			eTypeStr = '入界';
            	};
            	return (isAllowStr + eTypeStr);
            },
            /**
			 * @Des 翻译 配置人员组
			 * @Auth
			 * @Date 2021/8/2
			 */
            transUserGroups(userGroupIds) {
            	// 空值 中止
            	if (this.$checkEmpty(userGroupIds)) return '无';

            	// list to array
            	let _userGroupIds = [];
            	if(userGroupIds.length > 0){
                    // 遍历
                    userGroupIds.forEach((row, index) => {
                        // 空值 跳过
                        if (this.$checkEmpty(row) || this.$checkEmpty(row.userGroupId)) return true;
                        _userGroupIds.push(row.userGroupId);
                    });
                }

            	// 人员组 名称
            	let userGroupNames = [];

            	if(this.userGroups.length > 0){
                    // 遍历
                    this.userGroups.forEach((row, index) => {
                        // 空值 跳过
                        if (this.$checkEmpty(row) || this.$checkEmpty(row.children)) return true;

                        // 人员组 list
                        let children = row.children;
                        // 遍历
                        children.forEach((r, i) => {
                            // 空值 跳过
                            if (this.$checkEmpty(r) || this.$checkEmpty(r.id) || this.$checkEmpty(r.name)) return true;
                            if (_userGroupIds.indexOf(r.id) > -1) {
                                // 人员组 名称
                                userGroupNames.push(r.name);
                            }
                        });
                    });
                }

            	return userGroupNames.join('，');
            },

            /**
			 * @Des 翻译 rules
			 * @Auth
			 * @Date 2021/8/2
			 */
            transRules(rules, eType) {
            	let oRules = {};
            	// String to Array
            	let rulesArray = rules.split(';');
            	// 聚众报警
            	if (eType == 7) {
            		// 聚众区域
            		let XY = !this.$checkEmpty(rulesArray[0]) ? rulesArray[0].split(',') : ['', ''];
            		// 聚众人数
            		let peopleNum = !this.$checkEmpty(rulesArray[1]) ? parseInt(rulesArray[1]) : '';
            		oRules['rangeX'] = XY[0];
            		oRules['rangeY'] = XY[1];
            		oRules['peopleNum'] = peopleNum;
            	}

            	return oRules;
            },

            /**
			 * @Des 整理 表单参数
			 * @Auth
			 * @Date 2021/8/2
			 */
			sortRowForm(row) {
				// 通用参数
				let overallForm = Object.assign({}, row);
				//delete overallForm['eFenceInConfList'];

				// 配置参数
				let eFenceInConfList = row.eFenceInConfList;
				let eConfForm = !this.$checkEmpty(eFenceInConfList) ? eFenceInConfList[0] : {};

				let eFenceInConfSetList = !this.$checkEmpty(eConfForm.eFenceInConfSetList) ? eConfForm.eFenceInConfSetList : {};
				// list to array
            	let userGroupIds = [];

            	if(eFenceInConfSetList.length > 0){
                    // 遍历
                    eFenceInConfSetList.forEach((row, index) => {
                        // 空值 跳过
                        if (this.$checkEmpty(row) || this.$checkEmpty(row.userGroupId)) return true;
                        userGroupIds.push(row.userGroupId);
                    });
                }

				return Object.assign({}, eConfForm, overallForm, {userGroupIds: userGroupIds});
			},

        },
        /**
         * @Des 监听
         * @Auth
         * @Date 2021/8/2
         */
        watch: {

        },

    }
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Fence/ElectronicFence.vue